import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Cog8ToothIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import { useUser } from '@lore/auth';
import NavigationLink from '@/pages/NavigationLink';
import isActiveChecker from '@/utils/isActiveChecker';
import isStaffUser from '../isStaffUser';
import { SETTINGS_ROOT_PATH, SETTINGS_VIDEOS_PATH } from '../constants';

/**
 * Staff-only "Settings" entry for the left navigation, with its children
 * listed (indented) directly beneath it. Renders nothing for non-staff users.
 *
 * Only the leaf item is highlighted, so a single row is marked active, the
 * same as every other nav item.
 */
StaffSettingsNav.propTypes = {
  currentRoute: PropTypes.string.isRequired
};

export default function StaffSettingsNav(props) {
  const { currentRoute } = props;
  const { t } = useTranslation();
  const currentUser = useUser();

  if (!isStaffUser(currentUser)) {
    return null;
  }

  const children = [
    { name: t('staff_settings.nav.videos'), icon: VideoCameraIcon, to: SETTINGS_VIDEOS_PATH }
  ];

  return (
    <div className="space-y-1">
      <NavigationLink
        name={t('staff_settings.nav.settings')}
        icon={Cog8ToothIcon}
        to={SETTINGS_ROOT_PATH}
        isActive={false}
      />
      <div className="pl-6 space-y-1">
        {children.map((item) => (
          <NavigationLink
            key={item.to}
            name={item.name}
            icon={item.icon}
            to={item.to}
            isActive={isActiveChecker.startsWith(currentRoute, item.to)}
          />
        ))}
      </div>
    </div>
  );
}
